/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockManageSummaryResVo
 */
export interface AdminStockManageSummaryResVo {
    /**
     * 库存保管会员数
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    stockUserCount?: number;
    /**
     * 库存SKU数
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    skuCount?: number;
    /**
     * 库存总数量
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    totalItemQty?: number;
    /**
     * 仓储计费体积(CBM)
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    totalCbm?: number;
    /**
     * 保管费欠费金额(韩币)
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    unpaidStorageFeeKrw?: number;
    /**
     * 欠费会员数
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    unpaidUserCount?: number;
    /**
     * 今日预计保管费(韩币)
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    todayStorageFeeKrw?: number;
    /**
     * 当月累计保管费(韩币)
     * @type {number}
     * @memberof AdminStockManageSummaryResVo
     */
    currentMonthStorageFeeKrw?: number;
}

/**
 * Check if a given object implements the AdminStockManageSummaryResVo interface.
 */
export function instanceOfAdminStockManageSummaryResVo(value: object): value is AdminStockManageSummaryResVo {
    return true;
}

export function AdminStockManageSummaryResVoFromJSON(json: any): AdminStockManageSummaryResVo {
    return AdminStockManageSummaryResVoFromJSONTyped(json, false);
}

export function AdminStockManageSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockManageSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'stockUserCount': json['stockUserCount'] == null ? undefined : json['stockUserCount'],
        'skuCount': json['skuCount'] == null ? undefined : json['skuCount'],
        'totalItemQty': json['totalItemQty'] == null ? undefined : json['totalItemQty'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'unpaidStorageFeeKrw': json['unpaidStorageFeeKrw'] == null ? undefined : json['unpaidStorageFeeKrw'],
        'unpaidUserCount': json['unpaidUserCount'] == null ? undefined : json['unpaidUserCount'],
        'todayStorageFeeKrw': json['todayStorageFeeKrw'] == null ? undefined : json['todayStorageFeeKrw'],
        'currentMonthStorageFeeKrw': json['currentMonthStorageFeeKrw'] == null ? undefined : json['currentMonthStorageFeeKrw'],
    };
}

export function AdminStockManageSummaryResVoToJSON(json: any): AdminStockManageSummaryResVo {
    return AdminStockManageSummaryResVoToJSONTyped(json, false);
}

export function AdminStockManageSummaryResVoToJSONTyped(value?: AdminStockManageSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stockUserCount': value['stockUserCount'],
        'skuCount': value['skuCount'],
        'totalItemQty': value['totalItemQty'],
        'totalCbm': value['totalCbm'],
        'unpaidStorageFeeKrw': value['unpaidStorageFeeKrw'],
        'unpaidUserCount': value['unpaidUserCount'],
        'todayStorageFeeKrw': value['todayStorageFeeKrw'],
        'currentMonthStorageFeeKrw': value['currentMonthStorageFeeKrw'],
    };
}

